<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <i class="icon-list"></i>
                <strong>{{ $t('targets.targets') }}</strong>
            </b-card-header>
            <b-card-body>
                <b-container fluid>
                    <b-row>
                        <b-col>
                            <div class="mb-3 text-right">
                                <span
                                    id="disable-btn-target-new-library-target-on-targets-page"
                                    class="d-inline-block"
                                    tabindex="0"
                                >
                                    <b-button
                                        id="btn-target-new-library-target-on-targets-page"
                                        class="mr-3"
                                        size="sm"
                                        type="button"
                                        :disabled="!permissionToCreateLibraryTarget"
                                        variant="outline-primary"
                                        @click="onClickNewLibraryTarget"
                                    >
                                        <b-tooltip
                                            target="disable-btn-target-new-library-target-on-targets-page"
                                            v-if="!permissionToCreateLibraryTarget"
                                        >
                                            {{ viewNewLibraryTargetTooltipMessage }}
                                        </b-tooltip>
                                        {{ $t('targets.newLibraryTarget') }}
                                    </b-button>
                                </span>
                                <span
                                    id="disable-btn-target-new-target-on-targets-page"
                                    class="d-inline-block"
                                    tabindex="0"
                                >
                                    <b-button
                                        id="btn-target-new-target-on-targets-page"
                                        size="sm"
                                        type="button"
                                        :disabled="!permissionToCreateTarget"
                                        variant="primary"
                                        @click="onClickNewTarget"
                                    >
                                        <b-tooltip
                                            target="disable-btn-target-new-target-on-targets-page"
                                            v-if="!permissionToCreateTarget"
                                        >
                                            {{ viewNewTargetTooltipMessage }}
                                        </b-tooltip>
                                        {{ $t('profile.targetsTable.newTarget') }}
                                    </b-button>
                                </span>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col offset-md="6">
                            <c-periods
                                :state="null"
                                :value.sync="filtered.periods"
                                :label="$t('targets.showInfoBySelectedPeriods')"
                                applyScopeNotArchived
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col v-if="hasAdminRole" xl="1">
                            <b-dropdown class="mb-3 btn-xs-block">
                                <template #button-content>
                                    <i v-if="isRenderingGoalBook" class="fa fa-spinner fa-spin" />
                                    <span v-else>{{ $t('targets.actions') }}</span>
                                </template>
                                <b-dropdown-item-button @click="openBulkEditingModal">
                                    <i class="fas fa-users-cog"></i>
                                    {{ $t('targets.bulkEditing') }}
                                </b-dropdown-item-button>
                                <b-dropdown-item-button @click="getGoalBook">
                                    <i class="fa fa-file-pdf-o"></i>
                                    {{ $t('targets.exportToPDF') }}
                                </b-dropdown-item-button>
                                <b-dropdown-item-button v-if="canDownloadGoals" @click="onClickDownloadTargets(false)">
                                    <i class="fas fa-download"></i>
                                    {{ $t('targets.download') }}
                                </b-dropdown-item-button>
                                <b-dropdown-item-button @click="onClickTargetsUpdateHandler">
                                    <i class="fas fa-upload"></i>
                                    {{ $t('targets.update') }}
                                </b-dropdown-item-button>
                                <b-dropdown-item-button @click="onClickCheckinsUploadHandler">
                                    <i class="fas fa-upload"></i>
                                    {{ $t('targets.bulkCheckin') }}
                                </b-dropdown-item-button>
                                <b-dropdown-item-button @click="onClickTargetsUploadeHandler">
                                    <i class="fas fa-upload"></i>
                                    {{ $t('people.targetUploads') }}
                                </b-dropdown-item-button>
                            </b-dropdown>
                        </b-col>

                        <b-col xl="6">
                            <b-form-group>
                                <b-form-input
                                    id="search-by-title"
                                    v-model="filtered.searchName"
                                    :placeholder="$t('targets.searchByName')"
                                />
                            </b-form-group>
                        </b-col>

                        <b-col class="right-btns" xl="4">
                            <div class="text-right">
                                <b-dropdown variant="light" class="mr-3">
                                    <template #button-content>
                                        {{ $t('form.button.filters') }}
                                    </template>

                                    <b-dropdown-form style="min-width: 768px">
                                        <b-form-group class="mt-3" :label="$t('targets.title')">
                                            <b-form-input
                                                id="search-by-title"
                                                v-model="filtered.searchText"
                                                :placeholder="$t('targets.searchByTitle')"
                                            />
                                        </b-form-group>

                                        <c-occupation-groups
                                            :showLabel="true"
                                            :state="null"
                                            :value.sync="filtered.occupationGroups"
                                        />
                                        <c-levels
                                            :state="null"
                                            :value.sync="filtered.levels"
                                            :label="$t('form.label.levels')"
                                        />
                                        <c-sections
                                            :state="null"
                                            :value.sync="filtered.sections"
                                            :label="$t('form.label.departments')"
                                        />
                                        <c-tags :state="null" :value.sync="filtered.tags" />

                                        <c-target-types :state="null" :value.sync="filtered.targetTypes" />
                                    </b-dropdown-form>
                                </b-dropdown>
                                <b-dropdown variant="light">
                                    <template #button-content>
                                        <i class="fas fa-eye"></i>
                                        {{ $t('people.columns') }}
                                    </template>
                                    <b-dropdown-form class="mr-6" style="min-width: 240px">
                                        <div
                                            :key="index"
                                            class="mb-3"
                                            v-for="(colGroup, index) in getColGroups(fields)"
                                        >
                                            <strong>{{ colGroup.colGroup }}</strong>
                                            <b-form-checkbox-group
                                                :id="`checkbox-group-` + index"
                                                v-model="showColumns"
                                                :options="getCheckboxOptions(colGroup.columns)"
                                                @change="showsAllExpectationsAndRealized"
                                                :name="`flavour-` + index"
                                                class="d-flex flex-column"
                                            />
                                        </div>
                                    </b-dropdown-form>
                                </b-dropdown>
                            </div>
                        </b-col>
                        <b-col xl="1">
                            <b-form-group class="text-right">
                                <b-form-select
                                    v-model="pagination.perPage"
                                    :options="pageOptions"
                                    @input="onChangePerPageHandler"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-table
                        hover
                        small
                        bordered
                        show-empty
                        :items="goals"
                        :fields="fields"
                        :busy="isLoading"
                        @head-clicked="onClickSortHandler"
                        :empty-text="$t('targets.emptyTable')"
                    >
                        <template #thead-top>
                            <tr>
                                <th
                                    v-for="(columnsGroup, index) in colGroups"
                                    :key="index"
                                    v-show="columnsGroup.columns.length"
                                    :colspan="columnsGroup.columns.length"
                                    class="text-center align-middle"
                                >
                                    {{ columnsGroup.colGroup }}
                                </th>
                            </tr>
                        </template>
                        <template #head(owner)="{ label, column }">
                            <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                        </template>
                        <template #head(only_focal_point)="{ label, column }">
                            <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                        </template>
                        <template #head(_select)>
                            <b-form-checkbox v-model="selectAll" @change="onClickSelectAllHandler" />
                        </template>
                        <template #head(title)="{ label, column }">
                            <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                        </template>
                        <template #head(progress)="{ label, column }">
                            <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                        </template>
                        <template #head(weight)="{ label, column }">
                            <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                        </template>
                        <template #head(achieved)="{ label, column }">
                            <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                        </template>
                        <template #head(level)="{ label, column }">
                            <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                        </template>
                        <template #head(unit_of_measurement)="{ label, column }">
                            <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                        </template>
                        <template #head(has_trigger_goal)="{ label, column }">
                            <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                        </template>
                        <template #head(section_name)="{ label, column }">
                            <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                        </template>
                        <template #head(period)="{ label, column }">
                            <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                        </template>
                        <template #head(target_library)="{ label, column }">
                            <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                        </template>
                        <template #head(visualization_type)="{ label, column }">
                            <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                        </template>

                        <template #cell(_select)="{ item }">
                            <b-form-checkbox
                                v-model="selected[item.id]"
                                @change="($event) => onClickSelectHandler(item, $event)"
                            />
                        </template>

                        <template #cell(title)="{ item }">
                            <b-link :to="`/v2/target/targets/view/${item.id}`">
                                {{ item.title }}
                            </b-link>
                        </template>
                        <template #cell(period)="{ item }">
                            <span>{{ item.period }}</span>
                        </template>
                        <template #cell(section_name)="{ item }">
                            <span>{{ item.section_name || '-' }}</span>
                        </template>
                        <template #cell(progress)="{ item }">
                            <div v-if="item.progress">
                                <span> {{ formatPercentage(item.progress) }}% </span>
                                <div class="progress-bar-padding">
                                    <progress-bar :value="item.progress" :color="item.colors.progress" />
                                </div>
                            </div>
                            <div v-else>
                                <span> {{ formatPercentage(item.progress) }}% </span>
                                <div class="progress-bar-padding">
                                    <progress-bar :value="item.progress" :color="item.colors.progress" :max="100" />
                                </div>
                            </div>
                        </template>
                        <template #cell(achieved)="{ item }">
                            <div v-if="item.achieved && !isGol">
                                <span> {{ formatPercentage(item.achieved) }}% </span>
                                <div class="progress-bar-padding">
                                    <progress-bar
                                        :value="parseFloat(item.achieved)"
                                        :color="item.colors.progress"
                                        :max="100"
                                    />
                                </div>
                            </div>
                            <div v-else-if="item.multiplier_achieved && isGol">
                                <span> {{ formatPercentage(item.multiplier_achieved) }}% </span>
                                <div class="progress-bar-padding">
                                    <progress-bar
                                        :value="item.multiplier_achieved"
                                        :color="item.colors.multiplier_achieved"
                                        :max="100"
                                    />
                                </div>
                            </div>
                            <div v-else>
                                <span>0%</span>
                                <div class="progress-bar-padding">
                                    <progress-bar :value="0" :max="100" />
                                </div>
                            </div>
                        </template>
                        <template #cell(weight)="{ item }">
                            {{
                                item.weight
                                    ? formatPercentage(item.weight) + '%'
                                    : formatPercentage(item.calibrated_weight) + '%'
                            }}
                        </template>
                        <template #cell(self_evaluation)="{ item }">
                            <div v-if="canViewGoalEvaluation(item, 'self')">
                                <div v-if="item.evaluations.owner != null">
                                    <span> {{ formatPercentage(item.evaluations.owner.weighted_evaluation) }}% </span>
                                    <div class="progress-bar-padding">
                                        <progress-bar
                                            :value="item.evaluations.owner.weighted_evaluation"
                                            :color="item.evaluations.owner.range_color"
                                        />
                                    </div>
                                </div>
                                <div v-else>-</div>
                            </div>
                            <div v-else>
                                <b-tooltip triggers="hover" :target="`tooltip-self-evaluation-${item.id}`">{{
                                    $t('targets.informations.withoutPermissionToSee')
                                }}</b-tooltip>
                                <i :id="`tooltip-self-evaluation-${item.id}`" class="fa fa-lock fa-lg" />
                            </div>
                        </template>
                        <template #cell(manager_evaluation)="{ item }">
                            <div v-if="canViewGoalEvaluation(item, 'manager')">
                                <div v-if="item.evaluations.manager != null">
                                    <span> {{ formatPercentage(item.evaluations.manager.weighted_evaluation) }}% </span>
                                    <div class="progress-bar-padding">
                                        <progress-bar
                                            :value="item.evaluations.manager.weighted_evaluation"
                                            :color="item.evaluations.manager.range_color"
                                        />
                                    </div>
                                </div>
                                <div v-else>-</div>
                            </div>
                            <div v-else>
                                <b-tooltip triggers="hover" :target="`tooltip-manager-evaluation-${item.id}`">{{
                                    $t('targets.informations.withoutPermissionToSee')
                                }}</b-tooltip>
                                <i :id="`tooltip-manager-evaluation-${item.id}`" class="fa fa-lock fa-lg" />
                            </div>
                        </template>
                        <template #cell(committee_evaluation)="{ item }">
                            <div v-if="canViewGoalEvaluation(item, 'committee')">
                                <div v-if="item.evaluations.committee != null">
                                    <span>
                                        {{ formatPercentage(item.evaluations.committee.weighted_evaluation) }}%
                                    </span>
                                    <div class="progress-bar-padding">
                                        <progress-bar
                                            :value="item.evaluations.committee.weighted_evaluation"
                                            :color="item.evaluations.committee.range_color"
                                        />
                                    </div>
                                </div>
                                <div v-else>-</div>
                            </div>
                            <div v-else>
                                <b-tooltip triggers="hover" :target="`tooltip-committee-evaluation-${item.id}`">
                                    {{ $t('targets.informations.withoutPermissionToSee') }}
                                </b-tooltip>
                                <i :id="`tooltip-committee-evaluation-${item.id}`" class="fa fa-lock fa-lg" />
                            </div>
                        </template>
                        <template #cell(level)="{ item }">
                            {{ getLevelTranslation(item.level) }}
                        </template>
                        <template #cell(unit_of_measurement)="{ item }">
                            {{ item.unit_of_measurement || emptyCellText }}
                        </template>
                        <template #cell(has_trigger_goal)="{ item }">
                            <is-checked-icon :isChecked="item.has_trigger_goal" />
                        </template>
                        <template #cell(target_library)="{ item }">
                            <is-checked-icon :isChecked="item.target_library" />
                        </template>
                        <template #cell(tags)="{ item }">
                            <item-with-popover :items="getTags(item.tags)" :itemsName="$t('targets.tags')" />
                        </template>
                        <template #cell(visualization_type)="{ item }">
                            <span>
                                {{ $t(`targets.visualizationType.${item.visualization_type}`) }}
                            </span>
                        </template>
                        <template #cell(expectations_and_realized)="row">
                            <b-form-checkbox v-model="row.detailsShowing" @change="row.toggleDetails" />
                        </template>
                        <template #row-details="row">
                            <div>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col"></th>
                                            <th
                                                scope="col"
                                                v-for="(obj, index) in row.item.expectation_and_realized"
                                                :key="index"
                                            >
                                                {{ getMonths(obj.date) }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th scope="row">
                                                {{ $t('targets.expectations') }}
                                            </th>
                                            <th
                                                scope="col"
                                                v-for="(obj, index) in row.item.expectation_and_realized"
                                                :key="index"
                                            >
                                                {{ obj.expectation || '-' }}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th scope="row">
                                                {{ $t('targets.realized') }}
                                            </th>
                                            <th
                                                scope="col"
                                                v-for="(obj, index) in row.item.expectation_and_realized"
                                                :key="index"
                                            >
                                                {{ obj.accomplished || '-' }}
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                        <template #cell(owner)="{ item }">
                            <b-link v-bind:disabled="isOwnerDeleted(item.user)" :to="`/v2/profile/${item.owner_id}`">
                                {{ item.owner }}
                            </b-link>
                        </template>
                        <template #cell(picture)="{ item }">
                            <b-link :to="`/v2/profile/${item.owner_id}`">
                                <avatar class="d-inline-block" :src="item.picture" :username="item.owner" :size="35" />
                            </b-link>
                        </template>
                        <template #cell(only_focal_point)="{ item }">
                            <is-checked-icon :isChecked="item.only_focal_point" />
                        </template>

                        <template #table-busy>
                            <div class="text-center my-2">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                        </template>

                        <template #table-caption>
                            <div>
                                <span v-if="!isLoading">
                                    {{
                                        $t('targetsBulkEdit.messages.fromToEntries', {
                                            from: pagination.from,
                                            to: pagination.to,
                                            total: pagination.total,
                                        })
                                    }}
                                </span>

                                <span v-if="goalTotal && !isLoading">
                                    {{
                                        $t('targetsBulkEdit.messages.selectedGoals', {
                                            count: goalTotal,
                                        })
                                    }}
                                </span>
                            </div>
                            <div class="d-flex justify-content-center">
                                <b-pagination
                                    class="mb-0"
                                    v-show="!isLoading"
                                    :total-rows="pagination.total"
                                    :per-page="pagination.perPage"
                                    v-model="pagination.currentPage"
                                    @change="onChangePaginationHandler"
                                />
                            </div>
                        </template>
                    </b-table>
                </b-container>
                <b-modal
                    id="targets-update-modal"
                    ref="targetsUploadModal"
                    :title="$t('targets.targetsUpdate')"
                    size="md"
                    :no-close-on-esc="true"
                    :no-close-on-backdrop="true"
                    :hide-header-close="true"
                    @ok="submitUploadPeople"
                    @cancel="onClickClearFile"
                    :busy="isSubmitting"
                    :ok-disabled="disabledOkButton"
                >
                    <h6>{{ $t('targets.instructions.updateGoals') }}</h6>
                    <p>1. {{ $t('targets.instructions.applyFilters') }}</p>
                    <p>
                        2. {{ $t('targets.instructions.downloadTemplate') }}
                        <b-link @click="onClickDownloadTargets(true, false, false)" href="#">
                            {{ $t('targets.instructions.clickingHere') }}
                        </b-link>
                    </p>
                    <h6 class="mt-1">
                        {{ $t('targets.instructions.observations') }}
                    </h6>
                    <ul>
                        <li>
                            {{ $t('targets.instructions.doNotRenameColumns') }}
                        </li>
                        <li>{{ $t('targets.instructions.noFormulas') }}</li>
                        <li>
                            {{ $t('targets.instructions.changeWorksheetsContents') }}
                        </li>
                        <li>
                            {{ $t('targets.instructions.acceptedFormats') }}
                        </li>
                        <li>
                            {{ $t('targets.instructions.onlyGoalsWorksheetCanBeChanged') }}
                        </li>
                        <li>
                            {{ $t('targets.instructions.doNotChangeTheGrayColumns') }}
                        </li>
                    </ul>
                    <b-form-group :label="$t('form.label.file')" label-class="font-weight-bold">
                        <b-form-file
                            id="file"
                            v-model="file"
                            :placeholder="$t('form.placeholder.chooseFile')"
                            :accept="acceptedExtensions"
                            :browse-text="$t('form.button.search')"
                        ></b-form-file>
                        <div>
                            <small class="text-danger" v-show="fileTooLarge">
                                {{ $t('form.validations.fileTooLarge') }}
                            </small>
                        </div>
                        <div>
                            <small class="text-danger" v-show="invalidFileExtension">
                                {{ $t('form.validations.invalidExtension') }}
                            </small>
                        </div>
                    </b-form-group>
                </b-modal>
                <b-modal
                    id="targets-upload-modal"
                    ref="targetsUploadModal"
                    :title="$t('people.targetUploads')"
                    size="md"
                    :no-close-on-esc="true"
                    :no-close-on-backdrop="true"
                    :hide-header-close="true"
                    @ok="submitUploadPeople($event, true)"
                    @cancel="onClickClearFile"
                    :busy="isSubmitting"
                    :ok-disabled="disabledOkButton"
                >
                    <h6>{{ $t('targets.instructions.uploadGoals') }}</h6>
                    <p>
                        1. {{ $t('targets.instructions.downloadTemplate') }}
                        <b-link @click="onClickDownloadTargets(true, true, true)" href="#">
                            {{ $t('targets.instructions.clickingHere') }}
                        </b-link>
                    </p>
                    <h6 class="mt-1">
                        {{ $t('targets.instructions.observations') }}
                    </h6>
                    <ul>
                        <li>
                            {{ $t('targets.instructions.doNotRenameColumns') }}
                        </li>
                        <li>{{ $t('targets.instructions.noFormulas') }}</li>
                        <li>
                            {{ $t('targets.instructions.changeWorksheetsContents') }}
                        </li>
                        <li>
                            {{ $t('targets.instructions.insertInThirdRow') }}
                        </li>
                        <li>
                            {{ $t('targets.instructions.acceptedFormats') }}
                        </li>
                        <li>
                            {{ $t('targets.instructions.doNotChangeTheGrayColumns') }}
                        </li>
                    </ul>
                    <b-form-group :label="$t('form.label.file')" label-class="font-weight-bold">
                        <b-form-file
                            id="file"
                            v-model="file"
                            :placeholder="$t('form.placeholder.chooseFile')"
                            :accept="acceptedExtensions"
                            :browse-text="$t('form.button.search')"
                        ></b-form-file>
                        <div>
                            <small class="text-danger" v-show="fileTooLarge">
                                {{ $t('form.validations.fileTooLarge') }}
                            </small>
                        </div>
                        <div>
                            <small class="text-danger" v-show="invalidFileExtension">
                                {{ $t('form.validations.invalidExtension') }}
                            </small>
                        </div>
                    </b-form-group>
                </b-modal>
                <b-modal
                    id="checkins-upload-modal"
                    ref="checkinsUploadModal"
                    :title="$t('targets.bulkCheckin')"
                    size="md"
                    :no-close-on-esc="true"
                    :no-close-on-backdrop="true"
                    :hide-header-close="true"
                    @ok="submitCheckinUpload"
                    @cancel="onClickClearFile"
                    :busy="isSubmitting"
                    :ok-disabled="disabledOkButton"
                >
                    <h6>{{ $t('targets.instructions.updateCheckins') }}</h6>
                    <p>1. {{ $t('targets.instructions.applyFilters') }}</p>
                    <p>2. {{ $t('targets.instructions.selectGoals') }}</p>
                    <p>
                        3. {{ $t('targets.instructions.downloadTemplate') }}
                        <b-link @click="onClickDownloadCheckins" href="#">
                            {{ $t('targets.instructions.clickingHere') }}
                        </b-link>
                    </p>
                    <h6 class="mt-1">
                        {{ $t('targets.instructions.observations') }}
                    </h6>
                    <ul>
                        <li>
                            {{ $t('targets.instructions.doNotRenameColumns') }}
                        </li>
                        <li>{{ $t('targets.instructions.noFormulas') }}</li>
                        <li>
                            {{ $t('targets.instructions.acceptedFormats') }}
                        </li>
                        <li>
                            {{ $t('targets.instructions.doNotChangeTheGrayColumns') }}
                        </li>
                    </ul>
                    <b-form-group :label="$t('form.label.file')" label-class="font-weight-bold">
                        <b-form-file
                            id="file"
                            v-model="file"
                            :placeholder="$t('form.placeholder.chooseFile')"
                            :accept="acceptedExtensions"
                            :browse-text="$t('form.button.search')"
                        ></b-form-file>
                        <div>
                            <small class="text-danger" v-show="fileTooLarge">
                                {{ $t('form.validations.fileTooLarge') }}
                            </small>
                        </div>
                        <div>
                            <small class="text-danger" v-show="invalidFileExtension">
                                {{ $t('form.validations.invalidExtension') }}
                            </small>
                        </div>
                    </b-form-group>
                </b-modal>
            </b-card-body>
        </b-card>
        <router-view>
            <!-- here the ItemModal component will be rendered -->
        </router-view>
    </div>
</template>

<script>
import Vue from 'vue'
import i18n from '@/i18n'
import Avatar from 'vue-avatar'
import {
    getGoalsFromApi,
    getDownloadTargetsFromApi,
    uploadTargetsToApi,
    getGoalBookFromApi,
    getDownloadCheckinsFromApi,
    uploadCheckinsToApi,
} from './api'
import { groupBy, forEach, findIndex, sortBy, debounce, filter } from 'lodash'
import { isCompany } from '@/services/companies-custom-functions'
import ProgressBar from '@/views/components/progress-bar/ProgressBar'
import Multiselect from '@/views/components/selects/multiselect'
import {
    Tags as CTags,
    OccupationGroups as COccupationGroups,
    Periods as CPeriods,
    Levels as CLevels,
    SectionsWithoutLevel as CSections,
    TargetTypes as CTargetTypes,
} from '@/views/components/fields'
import mapperFiltersToApi from './mapperFiltersToApi'
import { formatPercentage, decimalFormat } from '@/lib/utils'
import shortMonths from '@/data/shortMonths'
import { getUserPermissions } from '@/services/user-permissions'
import Swal from 'sweetalert2'
import { EventBuzz } from '@/main'
import notification, { success } from '@/lib/notification'
import { userPermissionsMixin } from '@/mixins'

notification.init()

const goalEvaluationTypeToOperationsMapper = {
    self: {
        evaluate: 'allow_self_evaluation',
        view: 'allow_view_self_evaluation',
    },
    manager: {
        evaluate: 'allow_manager_evaluation',
        view: 'allow_view_manager_evaluation',
    },
    committee: {
        evaluate: 'allow_committee_to_evaluate_goals',
        view: 'allow_view_committee_evaluation',
    },
}

Vue.component('th-with-sort', {
    props: ['label', 'sortDirection'],

    computed: {
        sortIcon() {
            return this.sortDirection ? `fa-sort-${this.sortDirection}` : 'fa-sort'
        },
    },
    template: `
        <div class="c-th">
            <span class="mr-1">
                {{ label }}
            </span>
            <i :class="['fa', sortIcon]"></i>
        </div>
    `,
})

Vue.component('is-checked-icon', {
    props: ['isChecked'],
    template: `
        <i
            v-if="isChecked"
            class="far fa-check-circle fa-lg text-success"
        ></i>
        <i
            v-else
            class="far fa-times-circle fa-lg text-danger"
        ></i>
    `,
})

Vue.component('item-with-popover', {
    props: ['items', 'itemsName'],
    template: `
        <i
            class="fa fa-ellipsis-h"
            v-b-popover.hover="
                items ||
                $t('targets.goalHasNoItem',
                    {
                        item: itemsName
                    }
                )
            "
        ></i>
    `,
})

const allowedExtensions = ['xls', 'xlsx', 'xml', 'xlsm', 'csv']

export default {
    name: 'List',
    components: {
        Avatar,
        Multiselect,
        CTags,
        COccupationGroups,
        CPeriods,
        CLevels,
        CSections,
        CTargetTypes,
        ProgressBar,
    },
    mixins: [userPermissionsMixin],
    data() {
        return {
            isGol: isCompany('gol') || isCompany('testegol'),
            goalTotal: 0,
            goalsTotal: 0,
            selectedIds: [],
            selected: {},
            selectAll: {},
            tagsReady: false,
            showDetails: false,
            filteredTags: [],
            dateKpiCheckins: [],
            expectationAndRealized: [],
            showColumns: [],
            colGroups: [],
            goals: [],
            fields: [
                {
                    key: '_select',
                    order: -1,
                    label: 'Select',
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.select'),
                    thClass: '',
                    tdClass: '',
                },
                {
                    key: 'picture',
                    order: 0,
                    label: i18n.t('targets.picture'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.user'),
                    thClass: '',
                    tdClass: '',
                },
                {
                    key: 'owner',
                    order: 1,
                    label: i18n.t('targets.name'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.user'),
                    thClass: '',
                    tdClass: '',
                },
                {
                    key: 'only_focal_point',
                    order: 2,
                    label: i18n.t('targets.isFocalPoint'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.user'),
                    thClass: 'd-none',
                    tdClass: 'd-none',
                },
                {
                    key: 'occupation_group',
                    order: 3,
                    label: i18n.t('targets.occupationGroup'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.user'),
                    thClass: 'd-none',
                    tdClass: 'd-none',
                },
                {
                    key: 'title',
                    order: 4,
                    label: i18n.t('targets.title'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: '',
                    tdClass: '',
                },
                {
                    key: 'period',
                    order: 5,
                    label: i18n.t('targets.period'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: '',
                    tdClass: '',
                },
                {
                    key: 'level',
                    order: 6,
                    label: i18n.t('targets.level'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: '',
                    tdClass: '',
                },
                {
                    key: 'section_name',
                    order: 7,
                    label: i18n.t('people.team'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: '',
                    tdClass: '',
                },
                {
                    key: 'progress',
                    order: 8,
                    label: i18n.t('targets.progress'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: '',
                    tdClass: '',
                },
                {
                    key: 'weight',
                    order: 9,
                    label: i18n.t('targets.weight'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: '',
                    tdClass: '',
                },
                {
                    key: 'achieved',
                    order: 11,
                    label: i18n.t('profile.table.details.achieved'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: '',
                    tdClass: '',
                },
                {
                    key: 'self_evaluation',
                    order: 12,
                    label: i18n.t('profile.targetsTable.selfEvaluate'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: '',
                    tdClass: '',
                },
                {
                    key: 'manager_evaluation',
                    order: 13,
                    label: i18n.t('profile.targetsTable.managerEvaluate'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: '',
                    tdClass: '',
                },
                {
                    key: 'committee_evaluation',
                    order: 14,
                    label: i18n.t('profile.targetsTable.committeeEvaluation'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: '',
                    tdClass: '',
                },
                {
                    key: 'unit_of_measurement',
                    order: 15,
                    label: i18n.t('targets.unitOfMeasurement'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: 'd-none',
                    tdClass: 'd-none',
                },
                {
                    key: 'target_library',
                    order: 17,
                    label: i18n.t('targets.isLibraryTarget'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: 'd-none',
                    tdClass: 'd-none',
                },
                {
                    key: 'tags',
                    order: 19,
                    label: i18n.t('targets.tags'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: 'd-none',
                    tdClass: 'd-none',
                },
                {
                    key: 'visualization_type',
                    order: 20,
                    label: i18n.t('targets.visualizationType.visualizationType'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: 'd-none',
                    tdClass: 'd-none',
                },
                {
                    key: 'expectations_and_realized',
                    order: 21,
                    label: i18n.t('targets.expectations_and_realized'),
                    class: 'text-center align-middle',
                    colGroup: i18n.t('targets.goal'),
                    thClass: 'd-none',
                    tdClass: 'd-none',
                },
            ],
            emptyCellText: '-',
            sortedBy: { current: 'title', title: 'asc' },
            pageOptions: ['5', '10', '20', '30', '50'],
            pagination: {
                total: null,
                perPage: 10,
                from: null,
                to: null,
                currentPage: 1,
            },
            columnsNotAllowedToSortedBy: [
                'picture',
                'expectations_and_realized',
                'tags',
                'self_evaluation',
                'manager_evaluation',
                'committee_evaluation',
                'occupation_group',
                '_select',
            ],
            searchText: null,
            isLoading: true,
            filtered: {
                tags: [],
                owners: [],
                occupationGroups: [],
                periods: [],
                levels: [],
                sections: [],
                searchText: '',
                searchName: '',
                targetTypes: [],
            },
            userPermissions: getUserPermissions(),
            isRenderingGoalBook: false,
            file: null,
            fileToUpload: null,
            isSubmitting: false,
        }
    },
    created() {
        EventBuzz.$on('update-bulk-editing-targets', () => {
            this.selected = []
            this.goalTotal = 0
            this.onChangeFilteredHandler()
        })
        this.$store.dispatch('clear')
    },
    mounted() {
        this.debouncedSearchHandler = debounce(this.onChangeFilteredHandler, 700)
        this.userPermissions = getUserPermissions()
        this.showColumns = filter(this.fields, { thClass: '' })
        this.colGroups = this.getColGroups(this.fields)
    },
    methods: {
        canViewGoalEvaluation(goal, evaluationType) {
            if (this.hasAdminRole) {
                return true
            }

            const isOwner = this.currentUser.id == goal.owner_id
            const isOwnerManager = this.currentUser.id == goal.user.manager_id
            const isCommitteeEvaluator = this.isCommitteeMember(
                this.currentUser.evaluator_committees,
                goal.user.rated_committees
            )
            const canView = this.hasEventPermission(
                this.currentUser.permissions,
                'goals',
                goal.level,
                goalEvaluationTypeToOperationsMapper[evaluationType].view
            )

            return (isOwner && canView) || isOwnerManager || isCommitteeEvaluator
        },
        getGoalBook() {
            const selectedGoalsIDs = Object.keys(this.selected).filter((goalID) => this.selected[goalID])

            Swal({
                type: 'warning',
                title: i18n.t('targets.exportToPDFWarning'),
                text: i18n.t('targets.exportToPDFPopUpWarning'),
                showCancelButton: false,
                showConfirmButton: true,
            }).then(() => {
                if (selectedGoalsIDs.length) {
                    this.isRenderingGoalBook = true
                    getGoalBookFromApi(selectedGoalsIDs).finally(() => {
                        this.isRenderingGoalBook = false
                    })
                } else {
                    Swal({
                        type: 'warning',
                        title: i18n.t('targets.changeGoalsWarning'),
                        cancelButtonText: i18n.t(`modal.close`),
                        showCancelButton: true,
                        showConfirmButton: false,
                    })
                }
            })
        },
        onClickDownloadTargets(isForUpload, cleanLines = false, isForUploadCreate = false) {
            if (this.canDownloadGoals) {
                let selectedGoalsIDs = cleanLines
                    ? ['0']
                    : Object.keys(this.selected).filter((goalID) => this.selected[goalID])

                Swal.queue([
                    {
                        title: cleanLines
                            ? i18n.t('notification.doYouWantToDownloadTemplateToUploadGoals')
                            : i18n.t('notification.doYouWantToDownloadTargets'),
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonText: i18n.t('notification.yes'),
                        cancelButtonText: i18n.t('notification.cancel'),
                        showLoaderOnConfirm: true,
                        allowOutsideClick: false,
                        preConfirm: () => {
                            const { current } = this.sortedBy
                            const { perPage, currentPage } = this.pagination

                            return getDownloadTargetsFromApi(
                                current,
                                this.sortedBy[current],
                                perPage,
                                currentPage,
                                mapperFiltersToApi(this.filtered),
                                selectedGoalsIDs,
                                isForUpload,
                                isForUploadCreate
                            ).then(() => {
                                Swal.insertQueueStep({
                                    type: 'success',
                                    title: i18n.t('notification.requestSentSuccessfully'),
                                    text: i18n.t('notification.youWillReceiveAnEmailWithTheDownloadFile'),
                                })
                            })
                        },
                    },
                ])
            } else {
                this.getEventPermissionGoals('show')
            }
        },
        onClickTargetsUpdateHandler() {
            this.$bvModal.show('targets-update-modal')
        },
        onClickTargetsUploadeHandler() {
            this.$bvModal.show('targets-upload-modal')
        },
        onClickDownloadCheckins() {
            if (
                this.userPermissions.is_admin ||
                this.userPermissions.current_event_permissions.goals.consolidated.show
            ) {
                const selectedGoalsIDs = Object.keys(this.selected).filter((goalID) => this.selected[goalID])

                Swal.queue([
                    {
                        title: i18n.t('notification.doYouWantToDownloadCheckinsList'),
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonText: i18n.t('notification.yes'),
                        cancelButtonText: i18n.t('notification.cancel'),
                        showLoaderOnConfirm: true,
                        allowOutsideClick: false,
                        preConfirm: () => {
                            const { current } = this.sortedBy
                            const { perPage, currentPage } = this.pagination

                            return getDownloadCheckinsFromApi(
                                current,
                                this.sortedBy[current],
                                perPage,
                                currentPage,
                                mapperFiltersToApi(this.filtered),
                                selectedGoalsIDs
                            ).then(() => {
                                Swal.insertQueueStep({
                                    type: 'success',
                                    title: i18n.t('notification.requestSentSuccessfully'),
                                    text: i18n.t('notification.youWillReceiveAnEmailWithTheDownloadFile'),
                                })
                            })
                        },
                    },
                ])
            } else {
                this.getEventPermissionGoals('show')
            }
        },
        onClickCheckinsUploadHandler() {
            this.$bvModal.show('checkins-upload-modal')
        },
        submitUploadPeople(event, isForUploadCreate = false) {
            event.preventDefault()
            this.isSubmitting = true
            uploadTargetsToApi(this.fileToUpload, isForUploadCreate)
                .then((response) => {
                    const status = response.data.messages[0].status
                    if (status == 'success') {
                        this.file = null
                        this.fileToUpload = null
                        success(i18n.t('notification.goalsUpdatedSuccessfully'))
                        this.$nextTick(() => {
                            this.$refs.targetsUploadModal.hide()
                        })
                    } else {
                        let error = response.data.messages[0].params

                        Swal({
                            type: 'warning',
                            title: i18n.t('notification.excel.error.' + error, {
                                item: i18n.t('targets.targets'),
                            }),
                        })
                        this.$refs.targetsUploadModal.hide()
                        this.file = null
                        this.fileToUpload = null
                    }
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        },
        submitCheckinUpload(event) {
            event.preventDefault()
            this.isSubmitting = true
            uploadCheckinsToApi(this.fileToUpload)
                .then((response) => {
                    const status = response.data.messages[0].status
                    if (status == 'success') {
                        this.file = null
                        this.fileToUpload = null
                        success(i18n.t('notification.checkinsUpdatedSuccessfully'))
                        this.$nextTick(() => {
                            this.$refs.checkinsUploadModal.hide()
                        })
                    } else {
                        let error = response.data.messages[0].params

                        Swal({
                            type: 'warning',
                            title: i18n.t('notification.excel.error.' + error, {
                                item: i18n.t('targets.checkins'),
                            }),
                        })
                        this.$refs.checkinsUploadModal.hide()
                        this.file = null
                        this.fileToUpload = null
                    }
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        },
        onClickClearFile() {
            this.file = null
            this.fileToUpload = null
        },
        getEventPermissionGoals(action) {
            switch (action) {
                case 'show':
                    action = 'showDenied'
                    break
                case 'edit':
                    action = 'editDenied'
                    break
                case 'checkin':
                    action = 'bulkCheckInsDenied'
                    break
                default:
                    action = 'onlyAdministratorFunction'
                    break
            }
            Swal({
                type: 'warning',
                title: i18n.t('notification.permissions.' + action, {
                    item: i18n.t('targets.target'),
                }),
                cancelButtonText: i18n.t(`modal.close`),
                showCancelButton: true,
                showConfirmButton: false,
            })
        },
        // Edição em massa
        openBulkEditingModal() {
            if (!this.$store.state.goal.items.length) {
                Swal({
                    type: 'warning',
                    title: i18n.t('targets.changeGoalsWarning'),
                    cancelButtonText: i18n.t(`modal.close`),
                    showCancelButton: true,
                    showConfirmButton: false,
                })
            } else if (!this.goalsAreActive) {
                const htmlMessage = this.getHtmlMessageCompletedGoals()
                Swal({
                    type: 'info',
                    title: i18n.t('notification.warning'),
                    html: htmlMessage,
                    cancelButtonText: i18n.t(`modal.close`),
                    showCancelButton: true,
                    showConfirmButton: false,
                })
            } else {
                this.$router.push({ path: 'list/bulk-editing' })
            }
        },
        onClickSelectAllHandler(isSelected) {
            isSelected ? this.$store.dispatch('loadItems', this.goals) : this.$store.dispatch('removeItems', this.goals)

            this.goals.map((goal) => {
                if (goal.currentPage == this.pagination.currentPage) {
                    this.selected[goal.id] = isSelected
                    this.onCounter(true, isSelected)
                    this.selectedIds.push(goal.id)
                }
            })
        },
        onClickSelectHandler(goal, isSelected) {
            isSelected ? this.$store.dispatch('loadItem', goal) : this.$store.dispatch('removeItem', goal)
            this.onCounter(false, isSelected)
        },
        getCompletedGoals() {
            return this.$store.state.goal.items.filter((goal) => {
                return goal.status == 'completed'
            })
        },
        getHtmlMessageCompletedGoals() {
            const goals = this.getCompletedGoals()
            let div = document.createElement('div')
            let list = document.createElement('ul')
            let h5 = document.createElement('h5')
            let h5Text = document.createTextNode(i18n.t('targets.informations.targetsWithStatusCompleted') + ':')

            list.className = 'list-group'

            goals.forEach((goal) => {
                let item = document.createElement('li')
                let content = document.createTextNode(goal.title)
                item.appendChild(content)
                item.className = 'd-flex list-group-item justify-content-center'
                list.appendChild(item)
            })

            h5.appendChild(h5Text)
            div.appendChild(h5)
            div.appendChild(list)

            return div
        },
        onCounter(selectedAll, isSelected) {
            const selectedGoalsIDs = Object.keys(this.selected).filter((goalID) => this.selected[goalID])

            if (isSelected && selectedAll) {
                this.goalTotal = selectedGoalsIDs.length - 1
            }

            if (isSelected) {
                this.goalTotal++
            } else {
                this.goalTotal--
            }
        },
        showsAllExpectationsAndRealized(array) {
            array.map((item) => {
                this.showDetails = false

                if (item.key === 'expectations_and_realized') {
                    this.showDetails = true
                }
                this.onChangeFilteredHandler()
            })
        },
        formatPercentage(number) {
            return formatPercentage(decimalFormat(number))
        },
        onClickNewTarget() {
            if (this.permissionToCreateTarget) {
                return this.$router.push({
                    path: '/v2/target/targets/new',
                })
            }
        },
        onClickNewLibraryTarget() {
            if (this.permissionToCreateLibraryTarget) {
                return this.$router.push({
                    path: '/v2/target/targets/new?libraryTarget=1',
                })
            }
            Swal({
                type: 'warning',
                text: i18n.t('notification.permissions.createDenied', {
                    item: i18n.t('targets.libraryTarget'),
                }),
            })
        },
        getLevelTranslation(level) {
            return level === 'unit'
                ? i18n.t('targets.organization')
                : level === 'department'
                ? i18n.t('targets.team')
                : level === 'personal'
                ? i18n.t('targets.personal')
                : null
        },
        getMonths(date) {
            const month = shortMonths.find((month) => month.value == date)
            return month.label || null
        },
        getTags(tags) {
            const tagsTitle = tags.map((tag) => tag.title)

            return tagsTitle.join(', ')
        },
        onClickSortHandler(columnName) {
            if (this.columnsNotAllowedToSortedBy.includes(columnName)) {
                return false
            }
            this.sortedBy = {
                ...this.sortedBy,
                [columnName]: this.sortedBy[columnName] === 'asc' ? 'desc' : 'asc',
                current: columnName,
            }

            const { perPage, currentPage } = this.pagination
            this.getGoalsFromApi(
                columnName,
                this.sortedBy[columnName],
                perPage,
                currentPage,
                mapperFiltersToApi(this.filtered)
            )
        },
        onChangePerPageHandler(perPage) {
            const { current } = this.sortedBy

            this.getGoalsFromApi(current, this.sortedBy[current], perPage, 1, mapperFiltersToApi(this.filtered))
        },
        onChangePaginationHandler(currentPage) {
            const { current } = this.sortedBy

            this.getGoalsFromApi(
                current,
                this.sortedBy[current],
                this.pagination.perPage,
                currentPage,
                mapperFiltersToApi(this.filtered)
            )
        },
        onChangeFilteredHandler(currentPage) {
            const { current } = this.sortedBy
            this.getGoalsFromApi(
                current,
                this.sortedBy[current],
                this.pagination.perPage,
                currentPage,
                mapperFiltersToApi(this.filtered)
            )
        },
        getGoalsFromApi(orderBy, sortedBy, perPage, currentPage, filtered) {
            this.isLoading = true

            getGoalsFromApi(orderBy, sortedBy, perPage, currentPage, filtered)
                .then((resp) => {
                    const {
                        data: {
                            data: { data, current_page, per_page, total, from, to },
                        },
                    } = resp

                    this.goalsTotal = total

                    this.goals = data.map((item) => item)

                    this.goals =
                        data.map((item) => ({
                            ...item,
                            currentPage: current_page,
                            _showDetails: this.showDetails,
                        })) || []
                    this.pagination = {
                        total,
                        perPage: per_page,
                        currentPage: current_page,
                        from,
                        to,
                    }
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        getColGroups(fields) {
            fields = sortBy(fields, [
                function (field) {
                    return field.order
                },
            ])

            const colGroupFields = groupBy(fields, 'colGroup')

            let colGroup = []
            forEach(colGroupFields, function (itens, key) {
                let colGroupObj = {
                    colGroup: key,
                    columns: itens,
                }
                colGroup.push(colGroupObj)
            })

            return colGroup
        },
        getCheckboxOptions(columns) {
            return columns.map((column) => {
                return {
                    text: column.label,
                    value: column,
                }
            })
        },
        isOwnerDeleted(user) {
            return !user
        },
    },
    computed: {
        hasAdminRole() {
            return (
                this.currentUser.role.name == 'administrator' ||
                this.currentUser.role.name == 'local_administrator' ||
                this.currentUser.role.name == 'god' ||
                this.currentUser.is_target_master
            )
        },
        goalsAreActive() {
            return this.$store.state.goal.items.every((goal) => {
                return goal.status == 'active'
            })
        },
        disabledOkButton() {
            return !this.file || this.fileTooLarge || this.invalidFileExtension
        },
        fileTooLarge() {
            if (this.file) {
                return this.file.size >> 20 > 20
            }
            return false
        },
        invalidFileExtension() {
            if (this.file) {
                const fileExtension = this.file.name.split('.').pop()
                return !allowedExtensions.includes(fileExtension)
            }
            return false
        },
        acceptedExtensions() {
            return allowedExtensions.map((ext) => '.' + ext).join(', ')
        },
        currentUser() {
            return this.$store.state.currentUser.user
        },
        canDownloadGoals() {
            const availableRoles = ['god', 'administrator', 'is_target_master']
            const rolesPermissionAndApi = this.userHasPermission(this.currentUser, availableRoles, [])
            const currentEventPermission = this.currentUser.permissions.goals.consolidated.show
            return rolesPermissionAndApi || currentEventPermission
        },
        viewNewLibraryTargetTooltipMessage() {
            return (
                this.$t('profile.targetsTable.userWithoutPermissionNewLibraryTarget', {
                    stageTitle: this.viewUserStage,
                }) + this.viewStageCriteriaMessage
            )
        },
        viewNewTargetTooltipMessage() {
            return (
                this.$t('profile.targetsTable.userWithoutPermissionNewTarget', {
                    stageTitle: this.viewUserStage,
                }) + this.viewStageCriteriaMessage
            )
        },
        viewStageCriteriaMessage() {
            const current = 0
            const firstEntryCriteria = 0
            if (!this.hasEntryCriteria) {
                return ''
            }
            const criterionIdentifier =
                this.$store.state.currentUser.user.events[current].event_has_criteria[firstEntryCriteria].criterion
                    .identifier
            return this.$t(`stages.eventHasCriteriaMessages.${criterionIdentifier}`)
        },
        hasEntryCriteria() {
            const current = 0
            return Object.keys(this.$store.state.currentUser.user.events[current].event_has_criteria).length
        },
        viewUserStage() {
            const current = 0
            return this.$store.state.currentUser.user.events[current].title
        },
        permissionToCreateLibraryTarget() {
            if (this.userPermissions.is_admin) {
                return true
            }
            const { has_goal: hasGoal } = this.userPermissions.modules
            const { create_library_goal: createLibraryGoal } =
                this.userPermissions.current_event_permissions.goals.consolidated
            if (hasGoal && createLibraryGoal) {
                return true
            }
            return false
        },
        permissionToCreateTarget() {
            if (this.userPermissions.is_admin) {
                return true
            }
            const { has_goal: hasGoal } = this.userPermissions.modules
            const { create } = this.userPermissions.current_event_permissions.goals.consolidated

            if (hasGoal && create) {
                return true
            }
            return false
        },
    },
    watch: {
        pagination: function () {
            this.selectAll = this.goals.every((goal) => {
                return this.selected[goal.id] === true
            })
        },
        'filtered.tags'() {
            this.onChangeFilteredHandler()
        },
        'filtered.occupationGroups'() {
            this.onChangeFilteredHandler()
        },
        'filtered.isTriggerGoal'() {
            this.onChangeFilteredHandler()
        },
        'filtered.periods'() {
            this.onChangeFilteredHandler()
        },
        'filtered.levels'() {
            this.onChangeFilteredHandler()
        },
        'filtered.sections'() {
            this.onChangeFilteredHandler()
        },
        'filtered.searchText'() {
            this.onChangeFilteredHandler()
        },
        'filtered.searchName'() {
            this.debouncedSearchHandler()
        },
        'filtered.targetTypes'() {
            this.onChangeFilteredHandler()
        },
        showColumns(newColumns) {
            const fields = this.fields

            /**
             * Set which field must be showed
             */
            forEach(fields, function (element, index) {
                let isShow = findIndex(newColumns, (column) => {
                    return column.key == element.key
                })
                if (isShow < 0) {
                    fields[index].thClass = 'd-none'
                    fields[index].tdClass = 'd-none'
                } else {
                    fields[index].thClass = ''
                    fields[index].tdClass = ''
                }
            })

            this.colGroups = this.getColGroups(newColumns)
        },
        file() {
            if (this.file) {
                let reader = new FileReader()
                reader.readAsDataURL(this.file)
                reader.onload = (event) => {
                    this.fileToUpload = {
                        blob: event.target.result,
                        filename: this.file.name,
                    }
                }
            }
        },
    },
}
</script>

<style lang="scss" scope>
@import '@/scss/CustomMultiselect.scss';
#btn-target-new-library-target-on-targets-page:disabled {
    background-color: #e4e5e6;
    border-color: #bec0c0;
    color: #bec0c0;
    opacity: 1;
}
#btn-target-new-target-on-targets-page:disabled {
    background-color: #6e6e6e;
    border-color: #6e6e6e;
    color: #ffffff;
    opacity: 0.5;
}
.c-th:hover {
    cursor: pointer;
}
.progress-bar-padding {
    padding-right: 9px;
    padding-left: 9px;
}

.right-btns {
    margin-left: auto;
}
</style>
